import FacialStore from "@/modules/device/store/facial/facial.store";

export default {
  modules: {
    FacialStore,
  },
};
